var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 37.4206V38.1621C0 39.6974 1.2525 40.9497 2.78726 40.9497H16.2442H18.6031C31.3599 40.9497 41.1833 33.4566 41.1833 20.4755C41.1833 15.0361 39.6132 9.71627 33.7775 8.0402C31.1095 7.27507 27.4371 7.61775 24.8164 8.7156C22.1945 9.81471 20.6244 11.669 19.8044 13.436C18.9844 15.2005 18.9122 16.8779 19.2972 18.0455C19.6798 19.2132 20.5197 19.8736 21.3584 20.5328C20.9359 18.6586 20.5459 16.4019 22.6257 15.1096C31.4708 9.61408 33.9457 27.3742 24.8675 33.5887C18.5346 37.9228 8.0961 37.2848 0 37.4206Z",
    fill: "#1D72F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6031 5.91278e-05H2.78726C1.2525 5.91278e-05 0 1.25245 0 2.78771V30.3301C6.18152 29.4291 9.79049 27.5337 12.0638 25.1274C15.9055 20.8469 9.93168 18.5676 9.16069 22.0681C8.97962 22.8893 9.00342 23.8987 9.44879 24.8383C1.10259 17.0112 19.3508 -1.23862 34.5052 5.94792C31.0733 2.11602 25.1329 5.91278e-05 18.6031 5.91278e-05Z",
    fill: "#272A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsBlue);
export default __webpack_public_path__ + "static/media/DS-blue.7689e02c7468fadd9316ce6643a7408c.svg";
export { ForwardRef as ReactComponent };